<template>
  <div>
    <div class="flex flex_column flex_between modal-content modal-content--in-group">
      <div class="flex flex_column w_80 margin_top">
        <form class="flex_center">
					<p class="text_left ">{{ $t("debtorManagement.addDebtor.documents.info") }}</p>
          <div class="flex" v-for="n in 3" :key="n">
            <CommonPdfUpload
              class="flex_1 margin_r"
              :placeholderKey="`debtorManagement.addDebtor.documents.invoice${n}`"
              :ref="`invoiceUpload${n}`"
							:uploadFunction=" uploadDocument"
            ></CommonPdfUpload>
            <CommonPdfUpload
              class="flex_1"
              :placeholderKey="`debtorManagement.addDebtor.documents.payment${n}`"
              :ref="`paymentUpload${n}`"
							:uploadFunction=" uploadDocument"
            ></CommonPdfUpload>
          </div>
          <div class="flex">
            <CommonPdfUpload
              class="flex_1 margin_r"
              placeholderKey="debtorManagement.addDebtor.documents.financialStatementFile"
              ref="financialStatementFileUpload"
							:uploadFunction=" uploadDocument"
            ></CommonPdfUpload>
            <CommonPdfUpload
              class="flex_1"
              placeholderKey="debtorManagement.addDebtor.documents.otherFile"
              ref="otherFileUpload"
							:uploadFunction=" uploadDocument"
            ></CommonPdfUpload>
          </div>
        </form>
      </div>
    </div>

    <div class="flex flex_end w_100 margin_top">
      <template v-if="isEditMode">
        <md-button class="md-primary" @click="confirmSubmitDeborDocuments">
          {{ $t("common.save") }}
        </md-button>
      </template>
      <template v-else>
        <md-button class="md-blank margin_r" @click="submit">
          {{ $t("common.save") }}
        </md-button>
        <md-button class="md-primary" @click="submitToReview">
          {{ $t("debtorManagement.addDebtor.submitToReview") }}
        </md-button>
      </template>
    </div>
  </div>
</template>

<script>
import {debtorManagementApi} from "src/common/api/debtorManagementApi";
import CommonPdfUpload from "src/components/templates/common/CommonPdfUpload";

export default {
  props: {
		relationId: { type: Number, default: null }
  },
  mounted() {
    this.loadDebtorDocuments();
  },
  components: { CommonPdfUpload },
  methods: {
    getData() {
      return {
        firstInvoiceFileId: this.$refs.invoiceUpload1[0].getUploadedFile().fileId,
				firstAccountStatementFileId: this.$refs.paymentUpload1[0].getUploadedFile().fileId,
        secondInvoiceFileId: this.$refs.invoiceUpload2[0].getUploadedFile().fileId,
				secondAccountStatementFileId: this.$refs.paymentUpload2[0].getUploadedFile().fileId,
        thirdInvoiceFileId: this.$refs.invoiceUpload3[0].getUploadedFile().fileId,
				thirdAccountStatementFileId: this.$refs.paymentUpload3[0].getUploadedFile().fileId,
				financialStatementFileId: this.$refs.financialStatementFileUpload.getUploadedFile().fileId,
        otherFileId: this.$refs.otherFileUpload.getUploadedFile().fileId,
      };
    },
    submit() {
      this.$emit("submit-relation");
    },
    submitToReview() {
      this.$emit("review-relation");
    },
    close() {
      this.$emit("close");
    },
    uploadDocument(params) {
			return debtorManagementApi.operation.uploadSingleDebtorDocument({ file: params.file });
    },
    loadDebtorDocuments() {
      if (!this.relationId) {
				return
      }
			debtorManagementApi.inspection.getDebtorDocuments(this.relationId)
			.then(function(res) {
            let firstInvoiceFile = res.firstInvoiceFile;
            let firstAccountStatementFile = res.firstAccountStatementFile;
            let secondInvoiceFile = res.secondInvoiceFile;
            let secondAccountStatementFile = res.secondAccountStatementFile;
            let thirdInvoiceFile = res.thirdInvoiceFile;
            let thirdAccountStatementFile = res.thirdAccountStatementFile;
            let financialStatementFile = res.financialStatementFile;
            let otherFile = res.otherFile;
            if (firstInvoiceFile) {
					this.$refs.invoiceUpload1[0].changeFileData(firstInvoiceFile)
            }
            if (firstAccountStatementFile) {
					this.$refs.paymentUpload1[0].changeFileData(firstAccountStatementFile)
            }
            if (secondInvoiceFile) {
					this.$refs.invoiceUpload2[0].changeFileData(secondInvoiceFile)
            }
            if (secondAccountStatementFile) {
					this.$refs.paymentUpload2[0].changeFileData(secondAccountStatementFile)
            }
            if (thirdInvoiceFile) {
					this.$refs.invoiceUpload3[0].changeFileData(thirdInvoiceFile)
            }
            if (thirdAccountStatementFile) {
					this.$refs.paymentUpload3[0].changeFileData(thirdAccountStatementFile)
            }
            if (financialStatementFile) {
					this.$refs.financialStatementFileUpload.changeFileData(financialStatementFile)
            }
            if (otherFile) {
					this.$refs.otherFileUpload.changeFileData(otherFile)
            }
			}.bind(this))
			.catch(err => {
				this.toast(err)
			})

    },
    confirmSubmitDeborDocuments() {
      let option = {
				title: this.$t("debtorManagement.editDebtor.confirm.title") ,
        msg: this.$t("debtorManagement.editDebtor.confirm.text"),
				confirmFun: this.submitDeborDocuments
      };
      this.confirmMeg(option, true);
    },
    submitDeborDocuments() {
      let params = { id: this.relationId, documents: this.getData() };
			debtorManagementApi.operation.saveDebtorDocuments(params)
        .then(() => {
          this.$emit("relation-changed");
          this.toastSuccess();
			}).catch(this.toast);
		}

  },
  computed: {
    isEditMode() {
      return this.relationId;
		}
	}
};
</script>